export default "__VITE_ASSET__B50uc_Vm__"